<template>
  <ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(onSubmit)">
      <div class="flex border-b border-dark-b">
        <h2 class="text-xl md:text-2xl font-medium">Change Password</h2>
      </div>
      <div class="py-12">
        <div class="md:flex">
          <ValidationProvider
            v-slot="{ errors }"
            class="md:w-1/2 md:pr-5"
            rules="required"
          >
            <label class="font-medium">Current Password</label>
            <input
              class="form-input"
              type="password"
              placeholder="Current Password"
              name="Current Password"
              v-model="formData.current_password"
            >
            <div class="input-error">
              {{ errors[0] }}
            </div>
          </ValidationProvider>
        </div>
        <div class="md:flex">
          <ValidationProvider
            v-slot="{ errors }"
            class="md:w-1/2 md:pr-5"
            rules="required|min:8"
          >
            <label class="font-medium">New Password</label>
            <input
              class="form-input"
              type="password"
              name="Password"
              placeholder="New Password"
              v-model="formData.password"
            >
            <div class="input-error">
              {{ errors[0] }}
            </div>
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            class="md:w-1/2 md:pl-5"
            :rules="`required|min:8|match:${formData.password}`"
          >
            <label class="font-medium">Repeat New Password</label>
            <input
              class="form-input"
              type="password"
              name="Repeat Password"
              placeholder="Repeat New Password"
              v-model="formData.password_confirmation"
            >
            <div class="input-error">
              {{ errors[0] }}
            </div>
          </ValidationProvider>
        </div>
      </div>
      <div class="text-right pb-2.5">
        <button class="new-app-btn bg-blue">Save</button>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'Changepassword',
  data() {
    return {
      formData: {
        current_password: '',
        password: '',
        password_confirmation: ''
      }
    }
  },
  methods: {
    ...mapActions ([
      'changePassword'
    ]),
    async onSubmit() {
      const data = await this.changePassword(this.formData)
      if (data.result) {
        this.$notify({
          group: 'buyHive',
          type: 'success',
          text: data.message
        })
        this.formData = {}
        this.$router.push({ name: 'Profile' })
      } else {
        this.$notify({
          group: 'buyHive',
          type: 'error',
          text: data.message,
          duration: 7000
        })
      }
    }
  }
}
</script>
